import React, { PropsWithChildren, useCallback, useMemo } from 'react';
import { FlowContextWrapper } from '@getvim/flow-context-provider';
import { Loader } from '@getvim/atomic-ui';
import { DatasourceConfig, SourceConfigurations } from '../types';
import { orderAssistLogger } from '../logger';
import { AppRequiredState } from './order-assist-app/OrderAssistAppWrapper';

interface Props {
  sourceConfig: SourceConfigurations | undefined;
  datasourcesConfig: DatasourceConfig[] | undefined;
}

export type SearchRequiredState = AppRequiredState & {
  sourceConfig: SourceConfigurations;
  datasourcesConfig: DatasourceConfig[];
};

export const SourceConfigWrapper: React.FC<PropsWithChildren<Props>> = ({
  sourceConfig,
  datasourcesConfig,
  children,
}) => {
  const state = useMemo(() => {
    return {
      sourceConfig: Promise.resolve(sourceConfig),
      datasourcesConfig: Promise.resolve(datasourcesConfig),
    };
  }, [sourceConfig, datasourcesConfig]);

  const onError = useCallback((error) => {
    orderAssistLogger.error('Failed to fetch state in SourceConfigWrapper!', { error });
  }, []);

  return (
    <FlowContextWrapper state={state} loader={<Loader type="dots" />} onError={onError}>
      {children}
    </FlowContextWrapper>
  );
};
